import { AutogenLayoutlayout_dimuxref2 } from "./autogen/AutogenLayoutlayout_dimuxref2";
import {  DataDisplayEvent, DropdownItem,  DropdownSelectionEvent, Layout, Textbox } from "@mcleod/components";

export class layout_dimuxref2 extends AutogenLayoutlayout_dimuxref2 {

    override async onLoad() {
        this.textboxDimuiDesc.enabled = false;
        this.textboxDimuxLogin.enabled = false;
        this.textboxDimuxIdent.enabled = false;
        await this.sourceDimuidents.search( { dimui_ident: ">0" } );
        const items: DropdownItem[] = [];
        for( let i=0; i < this.sourceDimuidents.rowCount; i++ )
        {
            this.sourceDimuidents.rowIndex = i;
            const ident: any = this.sourceDimuidents.activeRow.data.dimui_ident;
            items.push(new DropdownItem(ident, ident));
        }
        this.textboxDimuxIdent.items = items;

        await this.sourceDiuser.search( { diuser_login: ">0", digroup_type: "M", diuser_status: "A" } );
        const items2: DropdownItem[] = [];
        for( let i=0; i < this.sourceDiuser.rowCount; i++ )
        {
            this.sourceDiuser.rowIndex = i;
            const login: any = this.sourceDiuser.activeRow.data.diuser_login;
            items2.push(new DropdownItem(login.toString(), login));
        }
        this.textboxDimuxLogin.items = items2;

    }


/** This is an event handler for the onDataDisplay event of textboxDimuxIdent. */
  textboxDimuxIdentOnDataDisplay(event: DataDisplayEvent) {
    const txtboxIdent = this.textboxDimuxIdent.text;
    for( let i=0; i < this.sourceDimuidents.rowCount; i++ )
    {
        this.sourceDimuidents.rowIndex = i;
        const ident = this.sourceDimuidents.activeRow.data.dimui_ident;
        if( ident == txtboxIdent )
            this.textboxDimuiDesc.text = this.sourceDimuidents.activeRow.data.dimui_desc;
    }
    if( txtboxIdent == null || txtboxIdent.length <= 0 )
        this.textboxDimuxIdent.enabled = true;
    else
        this.textboxDimuxIdent.enabled = false;
  }

/** This is an event handler for the afterDropdownSelection event of textboxDimuxIdent. */
  async textboxDimuxIdentAfterDropdownSelection(event: DropdownSelectionEvent) {
    const txtboxIdent = this.textboxDimuxIdent.text;
    await this.sourceDimuidents.search( { dimui_ident: txtboxIdent } );
    this.sourceDimuidents.rowIndex = 0;
    this.textboxDimuiDesc.text = this.sourceDimuidents.activeRow.data.dimui_desc;
  }

/** This is an event handler for the onDataDisplay event of textboxDimuxLogin. */
  textboxDimuxLoginOnDataDisplay(event: DataDisplayEvent) {
    const txtboxLogin = this.textboxDimuxLogin.text;
    if( txtboxLogin == null || txtboxLogin.length <= 0 )
        this.textboxDimuxLogin.enabled = true;
    else
        this.textboxDimuxLogin.enabled = false;
  }
}
